
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-index-ui',
  currentProjectVersion: 'static-2.46384',
  depVersions: {
  "crm-index-ui": "static-2.46384",
  "ably-hubspot-js": "static-1.435",
  "apollo-dlb": "static-3.41",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.2992",
  "calling-orchestration-shared-library": "static-1.29531",
  "card-associated-objects-lib": "static-1.38030",
  "card-associated-objects-lib-legacy": "static-1.5580",
  "client-types": "static-1.370",
  "commerce-contract-lib": "static-1.5228",
  "commerce-products-lib": "static-1.4140",
  "commerce-shared-components-lib": "static-1.14157",
  "commerce-tools-ui-lib": "static-1.5864",
  "commerce-tours-lib": "static-1.3073",
  "contextual-settings-lib": "static-1.1400",
  "credit-memos-ui-lib": "static-1.5430",
  "crm_data": "static-4.86161",
  "crm-cards-global-registry": "static-1.13954",
  "crm-common-dlb": "static-1.3892",
  "crm-component-utils": "static-1.33873",
  "crm-index-associations-lib": "static-1.4944",
  "crm-index-visualization-core": "static-1.2457",
  "crm-legacy-global-containers": "static-1.22375",
  "crm-legacy-links": "static-1.71046",
  "crm-message-bus": "static-1.35740",
  "crm-object-board-core": "static-1.12006",
  "crm-object-map": "static-1.1428",
  "crm-object-search-query-utilities": "static-1.5799",
  "crm-object-search-query-utilities-test-utils": "static-1.5462",
  "crm-pipeline-board-settings-lib": "static-1.25108",
  "crm-pipelines-api-client-types": "static-1.2935",
  "customer-data-bulk-actions": "static-1.29280",
  "customer-data-objects": "static-1.6158",
  "customer-data-objects-ui-components": "static-1.11454",
  "customer-data-properties": "static-1.44862",
  "customer-data-sidebar": "static-2.40111",
  "customer-data-views-management": "static-1.21707",
  "data-fetching-client": "static-1.8163",
  "data-privacy-hub-settings-service-types": "static-1.2811",
  "demographics-client": "static-1.3989",
  "dispatcher": "static-1.110",
  "embedded-academy-lib": "static-1.9649",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.293",
  "external-options-client-types": "static-1.2901",
  "feedback-loader": "static-1.26147",
  "foundations-components": "static-1.5736",
  "foundations-components-test-utils": "static-1.3221",
  "foundations-theming": "static-1.2881",
  "foundations-theming-specialty": "static-1.598",
  "framework-data-schema-quick-fetch": "static-1.5333",
  "framework-data-schema-resolvers": "static-1.5428",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.6896",
  "framework-data-table": "static-2.8135",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "growth-onboarding-beacon": "static-1.2202",
  "growth-payments-core": "static-1.20477",
  "head-dlb": "static-1.3679",
  "highcharts": "static-8.80",
  "history": "static-4.47",
  "hs-promise-utils": "static-1.4084",
  "hs-test-utils": "static-1.6575",
  "hub-http": "static-1.4751",
  "hubspot-apollo-client": "static-1.3395",
  "hubspot-dlb": "static-2.1289",
  "HubStyleTokens": "static-2.10063",
  "I18n": "static-7.1365",
  "immer": "static-1.33",
  "immutable": "static-2.19",
  "inbound-db-meta-service-client": "static-1.2589",
  "inbound-db-properties-service-client": "static-1.2767",
  "inbounddb-objects-service-types": "static-1.3043",
  "jasmine-immutable": "static-1.1529",
  "jasmine-runner": "static-1.4968",
  "laboratory-lib": "static-3.5829",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.4456",
  "marketplace-embed": "static-1.15528",
  "marketplace-ui-client-types": "static-1.10811",
  "object-builder-ui-client": "static-1.41024",
  "onboarding-scopes": "static-1.5113",
  "onboarding-tours": "static-1.13857",
  "payments-zero-states-lib": "static-1.13861",
  "pipeline-validation-client-types": "static-1.2701",
  "PortalIdParser": "static-2.272",
  "products-iframe-lib": "static-1.2130",
  "products-ui-components": "static-1.34662",
  "property-management-iframe": "static-1.7668",
  "quartz": "static-1.5323",
  "quick-fetch": "static-1.2795",
  "raven": "static-3.4440",
  "react": "static-7.151",
  "react-dlb": "static-1.50",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-4.5",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15175",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.4141",
  "recording-review-components-lib": "static-1.25598",
  "reference-resolvers-lite": "static-1.6517",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.6956",
  "reporting-data": "static-1.60835",
  "reporting-dlb": "static-1.53753",
  "reporting-testing-lib": "static-1.2770",
  "reporting-visualizations": "static-1.52915",
  "sales-views-client-types": "static-1.2926",
  "self-service-api": "static-1.8760",
  "settings-ui-lib": "static-1.11130",
  "signup-constants": "static-1.15807",
  "styled-components": "static-2.40",
  "superstore": "static-1.3350",
  "svh-onboarding-config-shared-lib": "static-1.1920",
  "tinymce": "static-6.5",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.10538",
  "ui-addon-draggable": "static-2.1196",
  "ui-addon-integrations-directory-panel": "static-2.6558",
  "ui-addon-upgrades": "static-9.15714",
  "ui-components-test-utils": "static-1.4203",
  "UIComponents": "static-3.7012",
  "usage-based-billing-components-lib": "static-1.2841",
  "usage-tracker-core": "static-1.5890",
  "user-context": "static-1.3721",
  "webpack-env": "static-1.54",
  "wootric-nps": "static-1.5538",
  "account-and-billing-components": "static-1.15985",
  "account-and-billing-fintech-outages": "static-3.14734",
  "accounting-extension-card-ui": "static-1.30668",
  "accounting-integrations-ui-components": "static-1.4524",
  "ai-components-ui-library": "static-1.4927",
  "apollo-link-hub-http": "static-2.3359",
  "attribution-sidebar-cards": "static-1.38583",
  "BizOpsCrmUIComponents": "static-1.39760",
  "call-widget-addon": "static-2.26720",
  "calling-integration-sdk-support": "static-1.24875",
  "calling-integration-timeline-event": "static-1.12573",
  "calling-internal-common": "static-1.29753",
  "calling-lifecycle-internal": "static-1.57992",
  "calling-ui-library": "static-1.63912",
  "card-biz-ops-customer-success-lib": "static-1.70979",
  "card-biz-ops-domain-controls-lib": "static-1.70980",
  "card-biz-ops-related-contacts-lib": "static-1.70979",
  "card-crm-attribution-lib": "static-1.49200",
  "card-deal-collaborators-lib": "static-1.32053",
  "card-deal-shared-view-lib": "static-1.62807",
  "card-engagement-attachments-lib": "static-1.67234",
  "card-gdpr-subscriptions-card-lib": "static-1.41376",
  "card-integration-card-lib": "static-1.67332",
  "card-linked-in-sales-navigator-lib": "static-1.34830",
  "card-lists-lib": "static-1.65399",
  "card-past-conversations-lib": "static-1.31981",
  "card-payment-history-lib": "static-1.30775",
  "card-playbooks-lib": "static-1.57489",
  "card-preview-highlight-lib": "static-1.69480",
  "card-profile-products-lib": "static-1.50961",
  "card-profile-quotes-lib": "static-1.78176",
  "card-properties-lib": "static-1.38020",
  "card-sales-activities-timeline": "static-1.32057",
  "card-target-account-lib": "static-1.66936",
  "card-website-activity-lib": "static-1.67744",
  "chatspot-widget-iframe": "static-1.14677",
  "collaboration-sidebar": "static-1.51434",
  "commerce-billing-lib": "static-1.14088",
  "commerce-subscription-cards-lib": "static-1.25253",
  "commerce-subscription-lib": "static-1.30427",
  "composer-plugins": "static-1.65995",
  "conversations-thread-view-crm-events": "static-1.28732",
  "copilot-toolkit": "static-1.5431",
  "credit-memos-iframe-lib": "static-1.5433",
  "crm_components": "static-3.86161",
  "crm_schema": "static-3.86197",
  "crm_ui": "static-5.86119",
  "crm_universal": "static-1.20305",
  "crm-activity-creator-interaction-window": "static-1.39948",
  "crm-activity-creator-interactions-legacy": "static-1.30417",
  "crm-activity-creator-widgets": "static-1.45999",
  "crm-associations-table": "static-1.35722",
  "crm-cards": "static-1.38578",
  "crm-cards-sdk": "static-1.37279",
  "crm-command-handler": "static-1.29809",
  "crm-display-components": "static-1.19623",
  "crm-events-components": "static-1.54607",
  "crm-events-data": "static-1.54619",
  "crm-fe-perf": "static-1.21551",
  "crm-index-ui-toolbar": "static-1.1671",
  "crm-index-view-table-edit-columns-modal": "static-1.15401",
  "crm-index-visualization-toolbar": "static-1.2095",
  "crm-index-visualization-toolbar-test-utils": "static-1.1467",
  "crm-links": "static-1.4681",
  "crm-object-board": "static-1.21929",
  "crm-object-board-card": "static-1.12004",
  "crm-object-preview": "static-1.20703",
  "crm-object-table": "static-1.16807",
  "crm-timeline": "static-1.82947",
  "crm-timeline-tasks": "static-1.32001",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.450",
  "customer-data-board": "static-1.19036",
  "customer-data-board-card": "static-1.18997",
  "customer-data-bulk-actions-container": "static-1.14992",
  "customer-data-communicator": "static-1.39467",
  "customer-data-email": "static-1.15448",
  "customer-data-filters-ui": "static-1.32979",
  "customer-data-property-utils": "static-1.6489",
  "customer-data-reference-ui-components": "static-1.11550",
  "customer-data-rte": "static-1.28345",
  "customer-data-ui-utilities": "static-1.8307",
  "deal-registration-ui": "static-1.29427",
  "deal-splits-cards-ui": "static-1.38847",
  "deal-splits-sidebar": "static-1.38752",
  "draft-email-branding-plugin": "static-2.19590",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.18903",
  "draft-signature-plugin": "static-1.19332",
  "email-confirm-ui": "static-2.4221",
  "EmailSignatureEditor": "static-1.19937",
  "ExportDialog": "static-6.8965",
  "ExtensionInstallHelpers": "static-1.526",
  "file-manager-components": "static-1.17622",
  "FileManagerLib": "static-1.33263",
  "flywheel-feedback-panel-components": "static-1.5846",
  "foundations-assets": "static-1.3485",
  "framework-app-settings-features-lib": "static-1.3615",
  "frontend-preferences-client": "static-1.6450",
  "getting-started-shared-tasks": "static-1.11340",
  "graphql": "static-1.58",
  "growth-data-modal": "static-1.3760",
  "growth-feature-usage-components": "static-1.4017",
  "growth-feature-usage-data": "static-1.4236",
  "growth-onboarding-empty-states": "static-1.3734",
  "HeadJS": "static-2.559",
  "hubspot-prosemirror": "static-1.12966",
  "hubspot-url-utils": "static-1.2942",
  "HubStyle": "static-2.10372",
  "icons": "static-2.591",
  "in-meeting-experience-ui-components": "static-1.16310",
  "InboxConnectUtils": "static-4.9228",
  "integration-settings-components": "static-1.9957",
  "integrations-directory-panel-lib": "static-1.7391",
  "invoices-card-lib": "static-1.50982",
  "invoices-iframe-lib": "static-1.50911",
  "invoices-ui-lib": "static-1.48853",
  "lead-tracking-lib": "static-1.33070",
  "marketing-contacts-lib": "static-1.7700",
  "marketing-contacts-ui": "static-1.6201",
  "marketing-event-cards-ui": "static-1.31046",
  "marketplace-ui-apps-core": "static-1.11942",
  "marketplace-ui-common": "static-1.13406",
  "metrics-js": "static-1.8314",
  "mobile-manifest-mixins": "static-1.330",
  "native-integrations-shared-strings": "static-1.6388",
  "nav-meta": "static-1.25101",
  "object-comments-thread-lib": "static-1.5473",
  "onboarding-tours-client": "static-1.3081",
  "orders-card-lib": "static-1.16234",
  "panel-deal-registration-ai-summary-lib": "static-1.21743",
  "partner-shared-view-ui": "static-1.41756",
  "playbooks-modal": "static-1.74663",
  "playlists-lib": "static-1.6306",
  "products-highlight-card-lib": "static-1.12427",
  "property-translator": "static-1.3945",
  "quartz-core": "static-1.4542",
  "quotes-ui-lib": "static-1.73368",
  "react-beautiful-dnd": "static-1.13",
  "react-colorpicker": "static-2.8796",
  "react-immutable-render-mixin": "static-1.9",
  "react-select-plus": "static-1.65",
  "recent-activities-card": "static-1.52471",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reference-resolvers": "static-1.6723",
  "reporting-action-components": "static-1.35392",
  "reporting-crm-object-table": "static-1.2006",
  "reporting-enablement": "static-1.16190",
  "reporting-ui-components": "static-2.58116",
  "reselect": "static-2.16",
  "rich-text-lib": "static-1.17085",
  "rpc-client-utils": "static-1.3303",
  "SalesContentIndexUI": "static-3.6764",
  "salesforce-sync-card-ui": "static-1.7510",
  "sanitize-text": "static-1.6767",
  "sequences-lib": "static-1.5578",
  "SharedI18nStrings": "static-1.161",
  "subscriptions-components": "static-1.40674",
  "svh-conversations-settings-lib": "static-1.1921",
  "tasks-lib": "static-1.32075",
  "timezone-utils": "static-2.3834",
  "transcript-sidebar": "static-1.61660",
  "trellis-ecosystem": "static-1.4249",
  "ui-addon-avatars": "static-2.8007",
  "ui-addon-form-validation": "static-1.9598",
  "ui-addon-i18n": "static-1.9483",
  "ui-addon-iframeable": "static-1.7467",
  "ui-addon-opt": "static-4.7234",
  "ui-addon-react-router-dom": "static-1.8182",
  "ui-addon-scriptloader": "static-1.10940",
  "ui-addon-teams": "static-1.19445",
  "ui-asset-management-lib": "static-1.8763",
  "ui-business-units-lib": "static-1.7451",
  "ui-gdpr-components": "static-1.8829",
  "ui-shepherd-react": "static-3.8607",
  "ui-universal-auth": "static-1.7371",
  "usage-tracker": "static-1.6040",
  "usage-tracker-container": "static-1.6030",
  "atom": "static-1.3826",
  "hs-lodash": "static-4.45",
  "planout": "static-5.12",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "sanitize": "static-1.2939",
  "hs-promise-rejection-tracking": "static-1.3967",
  "raven-hubspot": "static-1.4747",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.2252",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1600",
  "quartz-webpack": "static-1.1547",
  "ably": "static-1.18",
  "calling-orchestration-schema": "static-1.29756",
  "avatar-components": "static-1.975",
  "calling-global-api": "static-1.56610",
  "campaigns-lib": "static-1.21391",
  "card-payment-highlight-lib": "static-1.30909",
  "customer-data-tracking": "static-1.5381",
  "payment-link-components": "static-1.17736",
  "payments-embed-points-lib": "static-1.8884",
  "persist-promise": "static-1.2318",
  "PatternValidationJS": "static-1.437",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.1148",
  "products-ui-components-shared-msw-handlers": "static-1.7195",
  "hs-story-utils": "static-1.7960",
  "msw": "static-1.39",
  "payments-enrollment-embed-lib": "static-1.16987",
  "StyleGuideUI": "static-3.452",
  "ui-images": "static-2.802",
  "cv-backend-services": "static-1.1108",
  "growth-onboarding-confetti": "static-1.1675",
  "payments-post-enroll-local-storage-lib": "static-1.3651",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.43",
  "react-dnd-compat": "static-1.3210",
  "magpie-lib": "static-1.4244",
  "magpie-types": "static-1.3704",
  "adobe-sign-cards-lib": "static-1.12290",
  "ai-addon-copilot-preview": "static-1.4139",
  "automation-ui-crm-card-workflows-invoker": "static-1.4443",
  "buyer-intent-card": "static-1.15454",
  "card-call-summaries-lib": "static-1.29559",
  "card-company-summary-lib": "static-1.13108",
  "card-customer-spend-trends-lib": "static-1.20384",
  "card-flywheel-activity-history-lib": "static-1.1658",
  "card-flywheel-company-overview-lib": "static-1.10687",
  "card-flywheel-domain-review-history-lib": "static-1.315",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.10687",
  "card-guest-access-management-lib": "static-1.2258",
  "card-guided-execution-activities": "static-1.3625",
  "card-knowledge-base-lib": "static-1.6712",
  "card-lead-insights": "static-1.8745",
  "card-lead-qualification-lib": "static-1.24443",
  "card-object-highlight-lib": "static-1.942",
  "card-object-summary-lib": "static-1.2678",
  "card-other-tickets-lib": "static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.25179",
  "card-partner-client-unified-usage-score-lib": "static-1.19544",
  "card-prospecting-research-agent": "static-1.1633",
  "card-tasks-timeline-lib": "static-1.9577",
  "card-ticket-summary-lib": "static-1.11424",
  "crm-actions": "static-1.4624",
  "crm-associations-pivot": "static-1.33852",
  "crm-clv-report": "static-1.2510",
  "crm-data-highlights": "static-1.36260",
  "crm-events-viz-cards": "static-1.35490",
  "crm-events-viz-totals": "static-1.27043",
  "crm-extension": "static-1.35581",
  "crm-pipeline-approvals-lib": "static-1.18491",
  "crm-properties-list": "static-1.32898",
  "crm-property-history": "static-1.10958",
  "crm-quick-actions": "static-1.12408",
  "crm-relative-timeline": "static-1.12836",
  "crm-report": "static-1.36467",
  "crm-simple-deadline": "static-1.13055",
  "crm-stage-tracker": "static-1.31432",
  "crm-statistics": "static-1.25476",
  "custom-events-card-lib": "static-1.226",
  "customer-overview-card-lib": "static-1.3996",
  "customer-success-contacts-card-lib": "static-1.12063",
  "datawell-report-crm-card": "static-1.13824",
  "deal-summary-components": "static-1.14930",
  "docusign-cards-lib": "static-1.21799",
  "flywheel-growth-plans-crm-card": "static-1.1137",
  "guided-actions-card": "static-1.8663",
  "guided-selling-stage-tracker-card": "static-1.5739",
  "health-score-card-lib": "static-1.15346",
  "help-desk-insights-lib-crm-cards": "static-1.17686",
  "intelligence-overview-card": "static-1.9286",
  "intelligence-overview-lib": "static-1.7583",
  "invoices-history-card-lib": "static-1.25266",
  "lead-scores-card": "static-1.11754",
  "legacy-sidebar-card-lib": "static-1.28965",
  "payment-schedule-card-lib": "static-1.22555",
  "playbooks-card": "static-1.37373",
  "predictive-scores-card": "static-1.24965",
  "process-guide-cards": "static-1.3303",
  "products-cards-lib": "static-1.3736",
  "purchase-history-lib": "static-1.14920",
  "ui-google-drive-attachments": "static-1.947",
  "ui-google-drive-insights": "static-1.948",
  "customer-data-properties-shared-msw-handlers": "static-1.6140",
  "ts-schema": "static-1.2954",
  "framework-builder-read-service-client": "static-1.2876",
  "hub-http-shared-msw-handlers": "static-1.6810",
  "multi-currency-client-types": "static-1.2637",
  "fast-json-stable-stringify": "static-1.4",
  "csstype": "static-1.38",
  "jasmine": "static-4.2921",
  "usage-tracker-public": "static-1.5851",
  "content-assistance-lib": "static-1.6033",
  "crm-record-access-management-lib": "static-1.20359",
  "customer-data-content": "static-1.24088",
  "draft-content-plugins": "static-1.23664",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "enrichment-properties-lib": "static-1.8855",
  "FireAlarmUi": "static-1.3448",
  "flux-actions": "static-1.266",
  "marketing-contacts-client": "static-1.6202",
  "pipeline-governance-client-types": "static-1.2992",
  "prospecting-agent-lib": "static-1.6122",
  "react-virtualized": "static-2.73",
  "subscriptions-client": "static-1.40914",
  "surveymonkey-crm-card": "static-1.34799",
  "task-forms-lib": "static-1.35081",
  "autolinker": "static-3.11",
  "conditional-properties-service-client": "static-1.2753",
  "google-libphonenumber": "static-1.11",
  "calling-error-reporting": "static-1.29759",
  "card-subscription-highlight-lib": "static-1.32851",
  "invoices-highlight-card-lib": "static-1.48838",
  "orders-highlight-card-lib": "static-1.16517",
  "project-storage": "static-1.3273",
  "quotes-highlight-card-lib": "static-1.64657",
  "crm-export-dialog": "static-1.4870",
  "customer-data-filters": "static-1.46793",
  "FormUrlGenerator": "static-2.3283",
  "testing-library": "static-1.120",
  "academy-common-lib": "static-1.9107",
  "bend-plugin-foundations-components": "static-1.2004",
  "floating-ui": "static-1.28",
  "framer-motion": "static-1.40",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.331",
  "bend-plugin-foundations-theming": "static-1.1364",
  "foundations-theming-base": "static-1.1866",
  "customer-data-associations": "static-1.5779",
  "growth-onboarding-feedback-components": "static-1.5029",
  "commerce-analytics-service-client": "static-1.2378",
  "hs-test-utils-bend-plugin": "static-1.1686",
  "i18n-data": "static-1.195",
  "moment-timezone": "static-5.51",
  "marketplace-ui-details": "static-1.3306",
  "navigation-components": "static-1.13464",
  "ui-shepherd-tracker": "static-1.5988",
  "property-description-translator": "static-1.2409",
  "quartz-core-utils": "static-1.2190",
  "call-summary": "static-1.31304",
  "reporting-client-types": "static-1.1743",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9034",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "conversations-async-data": "static-2.6240",
  "conversations-error-reporting": "static-1.7523",
  "conversations-http": "static-1.3361",
  "conversations-internal-schema": "static-1.11218",
  "conversations-message-history": "static-1.9653",
  "routing-ui": "static-1.15144",
  "hubs-service-types": "static-1.31",
  "salesImages": "static-1.497",
  "trials-service-types": "static-1.2660",
  "react-flip-move": "static-1.46",
  "feature-store-service-types": "static-1.3252",
  "growth-monetization-service-types": "static-1.3259",
  "upgrade-management-service-types": "static-1.3243",
  "hub-http-janus": "static-1.631",
  "subscription-experience-data-types": "static-1.9906",
  "getting-started-shared-tasks-store": "static-1.10458",
  "final-form": "static-1.39",
  "fintech-outages-service-client-types": "static-1.11650",
  "transactions-exp-service-client-types": "static-1.11646",
  "conversations-skeleton-state": "static-1.5964",
  "integrations-lib": "static-1.9785",
  "chatspot-client-types": "static-1.8308",
  "chatspot-core": "static-1.14681",
  "ContentUtils": "static-1.62485",
  "sassPrefix": "static-1.129",
  "report-customization-components": "static-1.8095",
  "reporting-snowflake": "static-1.49459",
  "activity-history-lib": "static-1.1137",
  "assisted-buying-components": "static-1.5558",
  "bet-customer-success-shared-ui": "static-1.11551",
  "company-details-components": "static-1.4458",
  "company-details-service-types": "static-1.2502",
  "domain-review-history-lib": "static-1.1216",
  "flywheel-recent-conversions-lib": "static-1.807",
  "flywheel-reject-ql-lib": "static-1.828",
  "industries-core": "static-1.5324",
  "payment-method-components": "static-1.5113",
  "quote-checkout-common-lib": "static-1.8815",
  "quote-checkout-service-types": "static-1.2201",
  "calling-client-interface": "static-1.69151",
  "calling-cross-tab-library": "static-1.17732",
  "calling-integration-cross-tab": "static-1.16647",
  "calling-lifecycle-messages": "static-1.50289",
  "calling-lifecycle-usage-tracker": "static-1.4614",
  "calling-usage-tracker": "static-1.5075",
  "conversations-prop-types": "static-1.6003",
  "shared-worker-versioning": "static-1.9639",
  "universal-associations-select": "static-1.9349",
  "hubspot-prosemirror-plugins": "static-1.12959",
  "redux-actions": "static-3.7",
  "share-transcript-modal": "static-1.51304",
  "twilio-voice-sdk": "static-1.50",
  "worker-connection-library": "static-1.11066",
  "SafeStorage": "static-1.2970",
  "ui-partner-confirmation-links-components": "static-1.21062",
  "FileManagerCore": "static-1.33122",
  "crm-activity-creator-data": "static-1.40494",
  "multi-account-crm-panel-lib": "static-1.11395",
  "sequences-crm-lib": "static-1.22327",
  "quotes-modal-lib": "static-1.95323",
  "call-timeline-event": "static-1.49916",
  "crm-events": "static-1.54614",
  "crm-meetings-components-lib": "static-1.20823",
  "svh-tickets-lib": "static-1.12967",
  "composer-data": "static-1.24997",
  "conversations-inbox-message-history": "static-1.29031",
  "conversations-infrastructure": "static-1.7485",
  "conversations-internal-pub-sub": "static-1.14587",
  "conversations-platform": "static-1.3058",
  "conversations-thread-data": "static-1.62067",
  "crm-events-viz-core": "static-1.27834",
  "hubspotter-http": "static-1.3372",
  "react-transition-group": "static-1.7",
  "ui-addon-conversations-settings": "static-2.26900",
  "ui-suspension-banners-lib": "static-1.4983",
  "zorse-crm-components-lib": "static-1.5586",
  "crm-activity-creator-interactions": "static-1.39220",
  "framework-scoring-history-panel-lib": "static-1.9735",
  "MeetingsLib": "static-2.52763",
  "hub-http-contrib": "static-1.1749",
  "task-queues": "static-1.27863",
  "ui-addon-video-player": "static-1.7343",
  "card-past-feedback-lib": "static-1.35925",
  "location-customization-utils-lib": "static-1.3353",
  "all-properties-panel-lib": "static-1.1936",
  "crm-events-viz-timeline": "static-1.35498",
  "customer-data-modals": "static-1.3333",
  "merge-modal-lib": "static-1.6015",
  "predictive-scores-panel": "static-1.23967",
  "property-history-panel": "static-1.18781",
  "crm-source-interpretation-lib": "static-1.3834",
  "partner-shared-messages-lib": "static-1.12552",
  "ql-visibility-lib": "static-1.3750",
  "redux-mock-store": "static-1.8",
  "automation-platform-service-types": "static-1.2026",
  "guided-selling-core": "static-1.4270",
  "sales-execution-components": "static-1.7403",
  "credit-memos-highlight-card-lib": "static-1.4786",
  "breeze-intelligence-kit": "static-1.3780",
  "policy-lib": "static-1.5368",
  "ui-coaching-tips": "static-1.21731",
  "ui-coaching-tips-shared-config": "static-1.21717",
  "analytics_js": "static-1.3131",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.17730",
  "feedback-schema": "static-1.47708",
  "forms-utils-lib": "static-1.9876",
  "FormsCommonComponents": "static-1.80235",
  "integrations-tracking-lib": "static-1.4036",
  "MeetingsBase": "static-1.54354",
  "outpost": "static-1.2909",
  "partner-poi-timeline-event": "static-1.34053",
  "qualified-leads-embedded-lib": "static-1.41665",
  "quotes-crm-events-lib": "static-1.36745",
  "react-table": "static-1.15",
  "sales-clients-common": "static-1.44977",
  "sequences-client-types-lib": "static-1.5434",
  "sequences-crm-events-lib": "static-1.22133",
  "settings-ui-nav": "static-2.8607",
  "social-components-lib": "static-1.28307",
  "ui-addon-sales-email": "static-1.3772",
  "ui-tour-react": "static-1.10519",
  "urlinator": "static-1.3118",
  "outreach-assistant-email-generation": "static-1.2241",
  "quotes-client-types": "static-1.30734",
  "sales-email-signature-service-client": "static-1.2576",
  "customer-data-filters-ui-msw-helpers": "static-1.15411",
  "signup-ui-lego-core": "static-1.17817",
  "viral-links-lib": "static-1.5433",
  "media-bridge-lib": "static-1.16346",
  "video-data-lib": "static-1.28649",
  "FileManagerImages": "static-1.30773",
  "trellis-story-utils": "static-1.3122",
  "knowledge-content-types": "static-1.7596",
  "ui-addon-emoji-picker": "static-1.8487",
  "in-meeting-experience-client-types": "static-1.13009",
  "content-embed-lib": "static-1.5923",
  "crm-record-cards-service-types": "static-1.2611",
  "remote-ui": "static-1.39",
  "ui-extensions": "static-1.14275",
  "ui-extensions-remote-renderer": "static-1.11868",
  "universal-page-editor-lib": "static-1.1506",
  "developer-experience-shared-components": "static-1.8641",
  "immutable-less": "static-1.3129",
  "ui-extensibility-client-types": "static-1.2792",
  "react-window": "static-1.13",
  "markdown-it": "static-1.6",
  "hubspotter-http-shared-msw-handlers": "static-1.6808",
  "platform-navigation-bootstrap": "static-1.10964",
  "dashboard-lib": "static-1.74912",
  "share-with-third-party-component-lib": "static-1.7202",
  "data-quality-ui-library": "static-1.7259",
  "html-to-image": "static-1.29",
  "reporting-plugins": "static-1.6271",
  "reporting-reports": "static-1.60522",
  "data-token-picker": "static-1.13723",
  "navigation-messaging": "static-1.2791",
  "attribution-lib": "static-1.36834",
  "campaigns-build-lib": "static-1.6764",
  "marketing-platform-lib": "static-1.5227",
  "growth-onboarding-reliability": "static-1.3710",
  "sales-checkout-service-client": "static-1.2390",
  "amplitude-session-replay-browser": "static-1.6",
  "stripe-embedded-components": "static-1.4893",
  "idb-keyval": "static-1.20",
  "simple-logging-lib": "static-1.1615",
  "integrations-error-boundary-lib": "static-1.7199",
  "ai-settings-ui-library": "static-1.5599",
  "automation-enrollment-service-types": "static-1.2502",
  "crm-cards-test-utils": "static-1.37128",
  "renewal-center-service-types": "static-1.2760",
  "submissions-lib": "static-1.40696",
  "ui-forms-components": "static-1.7871",
  "portal-details-components": "static-1.13245",
  "ui-extensions-plugin-flywheel": "static-1.8809",
  "ui-product-approvals": "static-1.23295",
  "customer-success-client-types": "static-1.13979",
  "sales-enablement-lib": "static-1.10997",
  "sales-leader-insights-components-lib": "static-1.12764",
  "guided-actions-lib": "static-1.13891",
  "framework-scoring-client-types": "static-1.10787",
  "fsm": "static-1.2264",
  "card-bet-associated-companies-lib": "static-1.70958",
  "card-bet-deal-support-requests-lib": "static-1.61700",
  "card-bet-quotes-lib": "static-1.70965",
  "card-deal-splits-lib": "static-1.38233",
  "card-flywheel-ql-summary-lib": "static-1.39846",
  "card-flywheel-recent-conversions-lib": "static-1.39847",
  "card-invoices-lib": "static-1.50264",
  "card-marketing-event-about-lib": "static-1.50046",
  "card-marketing-event-activity-lib": "static-1.50045",
  "card-prospecting-notes": "static-1.32057",
  "card-qualified-leads-lib": "static-1.71121",
  "card-sfdcsync-lib": "static-1.50116",
  "card-workflows-lib": "static-1.67125",
  "integrations-sync-card-ui": "static-1.21114",
  "partner-poi-crm-card": "static-1.13507",
  "recording-preview-card": "static-1.10949",
  "ui-sales-order-wizard-card": "static-1.26099",
  "predictive-scores-lib-components": "static-1.22361",
  "process-guide-chirp": "static-1.3134",
  "gapi-client-types": "static-1.2",
  "google-picker-types": "static-1.2",
  "ui-google-drive-picker": "static-1.517",
  "deep-diff": "static-1.5",
  "academy-service-client": "static-1.2664",
  "marketplace-ui-reviews": "static-1.13365",
  "marketplace-ui-tracking": "static-1.7580",
  "cms-field-types": "static-1.3350",
  "content-icons-ui": "static-1.1860",
  "reporting-datasets-permissions-lib": "static-1.6553",
  "fintech-buying-service-clients": "static-1.2346",
  "account-and-billing-contacts-usage": "static-2.17442",
  "emoji-regex": "static-1.7",
  "signup-ui-full-screen-search": "static-1.9937",
  "billing-payments-client-types": "static-1.2663",
  "buying-experience-components": "static-1.8377",
  "checkout-service-types": "static-1.2758",
  "growth-pro-utils-lib": "static-1.7516",
  "audio-components": "static-1.4172",
  "video-components": "static-1.7003",
  "video-embed": "static-1.29492",
  "conversations-calling-message": "static-1.53692",
  "crm-events-viz-test-utils": "static-1.16454",
  "crm-pipeline-events-ui": "static-1.21684",
  "conversations-routing-lib": "static-1.5448",
  "conversations-visibility-tools": "static-1.4332",
  "data-ops-fullstory": "static-1.3892",
  "re-reselect": "static-1.4",
  "signup-ui-url-generator": "static-2.6618",
  "usage-tracker-anonymous": "static-1.4457",
  "usage-tracker-multi": "static-1.4454",
  "automation-ui-core": "static-2.15209",
  "automation-ui-permissions": "static-1.13571",
  "workspace-components": "static-1.2482",
  "settings-content-modals": "static-1.39016",
  "forms-ai-lib": "static-1.1977",
  "react-tinymce": "static-1.49835",
  "SharedLegalStrings": "static-1.1285",
  "tinymce-config": "static-2.48961",
  "meetings-client-types": "static-1.2660",
  "messaging-types-lib": "static-1.39568",
  "apps-service-types": "static-1.2786",
  "oauth-service-types": "static-1.2884",
  "platform-infra-nav-components": "static-1.6499",
  "campaign-roi-lib": "static-1.1989",
  "stripe-connect-js": "static-1.36",
  "customer-data-sidebar-test-utils": "static-1.34790",
  "form-builder-ui": "static-1.7667",
  "user-configuration-lib": "static-1.23777",
  "ui-deal-management-components-lib": "static-1.15057",
  "ui-signature-editor": "static-1.13098",
  "immerable": "static-1.2738",
  "social-insights-client-types": "static-1.17211",
  "automation-ui-routing": "static-1.14633",
  "automation-ui-source-apps": "static-1.12355",
  "ui-addon-draggable-compat": "static-2.2834",
  "access-control-lib": "static-1.9038",
  "EmailComponents": "static-1.48182",
  "EmailData": "static-1.46857",
  "redux-less": "static-2.8002",
  "tinymce-themes": "static-1.50929",
  "interframe": "static-3.3371",
  "tinymce-data": "static-1.35044",
  "tinymce-plugins": "static-1.52075",
  "ContentData": "static-1.62562",
  "marketing-email-service-types": "static-1.1397",
  "layout-dnd-components": "static-1.10506",
  "layout-dnd-utils": "static-1.9481",
  "app-users-service-client": "static-1.3578",
  "app-users-service-types": "static-1.2984",
  "framework-listing-lib": "static-2.21543",
  "mini-checkout-client": "static-1.23739",
  "onboarding-utils": "static-1.3906",
  "ContentComponents": "static-2.65443",
  "messaging-editing-lib": "static-1.39833",
  "ui-tool-access": "static-1.8612",
  "automation-ui-types": "static-1.13273",
  "NamespacedHubStyle": "static-2.8042",
  "codemirror": "static-5.69",
  "react-codemirror": "static-1.9162",
  "layout-data-lib": "static-1.7806",
  "framework-listing-lib-shared-msw-handlers": "static-1.6701",
  "touchless-buying-components": "static-1.3006",
  "merchandise-lib": "static-1.220",
  "data-token-views": "static-1.13704",
  "simple-menus-core": "static-1.13273",
  "simple-menus-lib": "static-1.14791",
  "ui-memberships-settings-lib": "static-1.27479",
  "videoconference-integration-components": "static-1.4659",
  "automation-applications-service-types": "static-1.2429",
  "ContentEditorUI": "static-2.70828",
  "short-messages-app-service-client": "static-1.2759",
  "web-interactives-components": "static-1.11151",
  "web-interactives-data": "static-1.11152",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "checkout-sdk": "static-3.20582",
  "upgrade-catalog-service-types": "static-1.2541",
  "seamless-immutable": "static-7.6",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.3617",
  "copilot-plugins": "static-1.5405",
  "cta-picker": "static-1.30526",
  "editor-components": "static-1.11582",
  "editor-iframe-lib": "static-1.6870",
  "error-messaging-js": "static-1.3854",
  "pictos": "static-7.158",
  "redux-request-state": "static-1.9147",
  "smart-content-core": "static-1.36485",
  "smart-content-lib": "static-1.37139",
  "social-composer-lib": "static-1.52654",
  "structured-content-lib": "static-1.19432",
  "theme-previewer-lib": "static-1.47039",
  "tinymce-copilot": "static-1.11029",
  "ui-active-theme-content-creator-lib": "static-1.30961",
  "xray-recommendation-lib": "static-1.5630",
  "hub-http-rxjs": "static-1.598",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "jquery": "static-3.6",
  "ai-rendering-library": "static-1.4306",
  "ui-brand-identity-lib": "static-1.7620",
  "fuzzy": "static-1.8",
  "codemirror-dlb": "static-1.52380",
  "redux-undo": "static-1.10",
  "highlight.js": "static-1.45"
},
  depPathPrefixes: {
  "crm-index-ui": "/crm-index-ui/static-2.46384",
  "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.2992",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.29531",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.38030",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.5580",
  "client-types": "/client-types/static-1.370",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.5228",
  "commerce-products-lib": "/commerce-products-lib/static-1.4140",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14157",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.5864",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3073",
  "contextual-settings-lib": "/contextual-settings-lib/static-1.1400",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.5430",
  "crm_data": "/crm_data/static-4.86161",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.13954",
  "crm-common-dlb": "/crm-common-dlb/static-1.3892",
  "crm-component-utils": "/crm-component-utils/static-1.33873",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.4944",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.2457",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22375",
  "crm-legacy-links": "/crm-legacy-links/static-1.71046",
  "crm-message-bus": "/crm-message-bus/static-1.35740",
  "crm-object-board-core": "/crm-object-board-core/static-1.12006",
  "crm-object-map": "/crm-object-map/static-1.1428",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.5799",
  "crm-object-search-query-utilities-test-utils": "/crm-object-search-query-utilities-test-utils/static-1.5462",
  "crm-pipeline-board-settings-lib": "/crm-pipeline-board-settings-lib/static-1.25108",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2935",
  "customer-data-bulk-actions": "/customer-data-bulk-actions/static-1.29280",
  "customer-data-objects": "/customer-data-objects/static-1.6158",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11454",
  "customer-data-properties": "/customer-data-properties/static-1.44862",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.40111",
  "customer-data-views-management": "/customer-data-views-management/static-1.21707",
  "data-fetching-client": "/data-fetching-client/static-1.8163",
  "data-privacy-hub-settings-service-types": "/data-privacy-hub-settings-service-types/static-1.2811",
  "demographics-client": "/demographics-client/static-1.3989",
  "dispatcher": "/dispatcher/static-1.110",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.9649",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.293",
  "external-options-client-types": "/external-options-client-types/static-1.2901",
  "feedback-loader": "/feedback-loader/static-1.26147",
  "foundations-components": "/foundations-components/static-1.5736",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3221",
  "foundations-theming": "/foundations-theming/static-1.2881",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.598",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5333",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5428",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.6896",
  "framework-data-table": "/framework-data-table/static-2.8135",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.2202",
  "growth-payments-core": "/growth-payments-core/static-1.20477",
  "head-dlb": "/head-dlb/static-1.3679",
  "highcharts": "/highcharts/static-8.80",
  "history": "/history/static-4.47",
  "hs-promise-utils": "/hs-promise-utils/static-1.4084",
  "hs-test-utils": "/hs-test-utils/static-1.6575",
  "hub-http": "/hub-http/static-1.4751",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3395",
  "hubspot-dlb": "/hubspot-dlb/static-2.1289",
  "HubStyleTokens": "/HubStyleTokens/static-2.10063",
  "I18n": "/I18n/static-7.1365",
  "immer": "/immer/static-1.33",
  "immutable": "/immutable/static-2.19",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2589",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2767",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3043",
  "jasmine-immutable": "/jasmine-immutable/static-1.1529",
  "jasmine-runner": "/jasmine-runner/static-1.4968",
  "laboratory-lib": "/laboratory-lib/static-3.5829",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.4456",
  "marketplace-embed": "/marketplace-embed/static-1.15528",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.10811",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.41024",
  "onboarding-scopes": "/onboarding-scopes/static-1.5113",
  "onboarding-tours": "/onboarding-tours/static-1.13857",
  "payments-zero-states-lib": "/payments-zero-states-lib/static-1.13861",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2701",
  "PortalIdParser": "/PortalIdParser/static-2.272",
  "products-iframe-lib": "/products-iframe-lib/static-1.2130",
  "products-ui-components": "/products-ui-components/static-1.34662",
  "property-management-iframe": "/property-management-iframe/static-1.7668",
  "quartz": "/quartz/static-1.5323",
  "quick-fetch": "/quick-fetch/static-1.2795",
  "raven": "/raven/static-3.4440",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.50",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15175",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.4141",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.25598",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6517",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.6956",
  "reporting-data": "/reporting-data/static-1.60835",
  "reporting-dlb": "/reporting-dlb/static-1.53753",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.2770",
  "reporting-visualizations": "/reporting-visualizations/static-1.52915",
  "sales-views-client-types": "/sales-views-client-types/static-1.2926",
  "self-service-api": "/self-service-api/static-1.8760",
  "settings-ui-lib": "/settings-ui-lib/static-1.11130",
  "signup-constants": "/signup-constants/static-1.15807",
  "styled-components": "/styled-components/static-2.40",
  "superstore": "/superstore/static-1.3350",
  "svh-onboarding-config-shared-lib": "/svh-onboarding-config-shared-lib/static-1.1920",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.10538",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1196",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6558",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15714",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4203",
  "UIComponents": "/UIComponents/static-3.7012",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.2841",
  "usage-tracker-core": "/usage-tracker-core/static-1.5890",
  "user-context": "/user-context/static-1.3721",
  "webpack-env": "/webpack-env/static-1.54",
  "wootric-nps": "/wootric-nps/static-1.5538",
  "account-and-billing-components": "/account-and-billing-components/static-1.15985",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.14734",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.30668",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4524",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.4927",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3359",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.38583",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.39760",
  "call-widget-addon": "/call-widget-addon/static-2.26720",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.24875",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.12573",
  "calling-internal-common": "/calling-internal-common/static-1.29753",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.57992",
  "calling-ui-library": "/calling-ui-library/static-1.63912",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.70979",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.70980",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.70979",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.49200",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.32053",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.62807",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.67234",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.41376",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.67332",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.34830",
  "card-lists-lib": "/card-lists-lib/static-1.65399",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.31981",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.30775",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.57489",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.69480",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.50961",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.78176",
  "card-properties-lib": "/card-properties-lib/static-1.38020",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.32057",
  "card-target-account-lib": "/card-target-account-lib/static-1.66936",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.67744",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.14677",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.51434",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.14088",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.25253",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30427",
  "composer-plugins": "/composer-plugins/static-1.65995",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.28732",
  "copilot-toolkit": "/copilot-toolkit/static-1.5431",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.5433",
  "crm_components": "/crm_components/static-3.86161",
  "crm_schema": "/crm_schema/static-3.86197",
  "crm_ui": "/crm_ui/static-5.86119",
  "crm_universal": "/crm_universal/static-1.20305",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.39948",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.30417",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.45999",
  "crm-associations-table": "/crm-associations-table/static-1.35722",
  "crm-cards": "/crm-cards/static-1.38578",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.37279",
  "crm-command-handler": "/crm-command-handler/static-1.29809",
  "crm-display-components": "/crm-display-components/static-1.19623",
  "crm-events-components": "/crm-events-components/static-1.54607",
  "crm-events-data": "/crm-events-data/static-1.54619",
  "crm-fe-perf": "/crm-fe-perf/static-1.21551",
  "crm-index-ui-toolbar": "/crm-index-ui-toolbar/static-1.1671",
  "crm-index-view-table-edit-columns-modal": "/crm-index-view-table-edit-columns-modal/static-1.15401",
  "crm-index-visualization-toolbar": "/crm-index-visualization-toolbar/static-1.2095",
  "crm-index-visualization-toolbar-test-utils": "/crm-index-visualization-toolbar-test-utils/static-1.1467",
  "crm-links": "/crm-links/static-1.4681",
  "crm-object-board": "/crm-object-board/static-1.21929",
  "crm-object-board-card": "/crm-object-board-card/static-1.12004",
  "crm-object-preview": "/crm-object-preview/static-1.20703",
  "crm-object-table": "/crm-object-table/static-1.16807",
  "crm-timeline": "/crm-timeline/static-1.82947",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.32001",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.450",
  "customer-data-board": "/customer-data-board/static-1.19036",
  "customer-data-board-card": "/customer-data-board-card/static-1.18997",
  "customer-data-bulk-actions-container": "/customer-data-bulk-actions-container/static-1.14992",
  "customer-data-communicator": "/customer-data-communicator/static-1.39467",
  "customer-data-email": "/customer-data-email/static-1.15448",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.32979",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6489",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11550",
  "customer-data-rte": "/customer-data-rte/static-1.28345",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8307",
  "deal-registration-ui": "/deal-registration-ui/static-1.29427",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.38847",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.38752",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.19590",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.18903",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.19332",
  "email-confirm-ui": "/email-confirm-ui/static-2.4221",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.19937",
  "ExportDialog": "/ExportDialog/static-6.8965",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.526",
  "file-manager-components": "/file-manager-components/static-1.17622",
  "FileManagerLib": "/FileManagerLib/static-1.33263",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.5846",
  "foundations-assets": "/foundations-assets/static-1.3485",
  "framework-app-settings-features-lib": "/framework-app-settings-features-lib/static-1.3615",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6450",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11340",
  "graphql": "/graphql/static-1.58",
  "growth-data-modal": "/growth-data-modal/static-1.3760",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4017",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.4236",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3734",
  "HeadJS": "/HeadJS/static-2.559",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.12966",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.2942",
  "HubStyle": "/HubStyle/static-2.10372",
  "icons": "/icons/static-2.591",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.16310",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.9228",
  "integration-settings-components": "/integration-settings-components/static-1.9957",
  "integrations-directory-panel-lib": "/integrations-directory-panel-lib/static-1.7391",
  "invoices-card-lib": "/invoices-card-lib/static-1.50982",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.50911",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.48853",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.33070",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7700",
  "marketing-contacts-ui": "/marketing-contacts-ui/static-1.6201",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.31046",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.11942",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13406",
  "metrics-js": "/metrics-js/static-1.8314",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.330",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6388",
  "nav-meta": "/nav-meta/static-1.25101",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.5473",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3081",
  "orders-card-lib": "/orders-card-lib/static-1.16234",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.21743",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.41756",
  "playbooks-modal": "/playbooks-modal/static-1.74663",
  "playlists-lib": "/playlists-lib/static-1.6306",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.12427",
  "property-translator": "/property-translator/static-1.3945",
  "quartz-core": "/quartz-core/static-1.4542",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.73368",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.8796",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-select-plus": "/react-select-plus/static-1.65",
  "recent-activities-card": "/recent-activities-card/static-1.52471",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reference-resolvers": "/reference-resolvers/static-1.6723",
  "reporting-action-components": "/reporting-action-components/static-1.35392",
  "reporting-crm-object-table": "/reporting-crm-object-table/static-1.2006",
  "reporting-enablement": "/reporting-enablement/static-1.16190",
  "reporting-ui-components": "/reporting-ui-components/static-2.58116",
  "reselect": "/reselect/static-2.16",
  "rich-text-lib": "/rich-text-lib/static-1.17085",
  "rpc-client-utils": "/rpc-client-utils/static-1.3303",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6764",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7510",
  "sanitize-text": "/sanitize-text/static-1.6767",
  "sequences-lib": "/sequences-lib/static-1.5578",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.161",
  "subscriptions-components": "/subscriptions-components/static-1.40674",
  "svh-conversations-settings-lib": "/svh-conversations-settings-lib/static-1.1921",
  "tasks-lib": "/tasks-lib/static-1.32075",
  "timezone-utils": "/timezone-utils/static-2.3834",
  "transcript-sidebar": "/transcript-sidebar/static-1.61660",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4249",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8007",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9598",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9483",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7467",
  "ui-addon-opt": "/ui-addon-opt/static-4.7234",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8182",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.10940",
  "ui-addon-teams": "/ui-addon-teams/static-1.19445",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8763",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7451",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8829",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8607",
  "ui-universal-auth": "/ui-universal-auth/static-1.7371",
  "usage-tracker": "/usage-tracker/static-1.6040",
  "usage-tracker-container": "/usage-tracker-container/static-1.6030",
  "atom": "/atom/static-1.3826",
  "hs-lodash": "/hs-lodash/static-4.45",
  "planout": "/planout/static-5.12",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "sanitize": "/sanitize/static-1.2939",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
  "raven-hubspot": "/raven-hubspot/static-1.4747",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2252",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1600",
  "quartz-webpack": "/quartz-webpack/static-1.1547",
  "ably": "/ably/static-1.18",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.29756",
  "avatar-components": "/avatar-components/static-1.975",
  "calling-global-api": "/calling-global-api/static-1.56610",
  "campaigns-lib": "/campaigns-lib/static-1.21391",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.30909",
  "customer-data-tracking": "/customer-data-tracking/static-1.5381",
  "payment-link-components": "/payment-link-components/static-1.17736",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.8884",
  "persist-promise": "/persist-promise/static-1.2318",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.1148",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7195",
  "hs-story-utils": "/hs-story-utils/static-1.7960",
  "msw": "/msw/static-1.39",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.16987",
  "StyleGuideUI": "/StyleGuideUI/static-3.452",
  "ui-images": "/ui-images/static-2.802",
  "cv-backend-services": "/cv-backend-services/static-1.1108",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1675",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3651",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.43",
  "react-dnd-compat": "/react-dnd-compat/static-1.3210",
  "magpie-lib": "/magpie-lib/static-1.4244",
  "magpie-types": "/magpie-types/static-1.3704",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.12290",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4139",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.4443",
  "buyer-intent-card": "/buyer-intent-card/static-1.15454",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.29559",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.13108",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.20384",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.1658",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.10687",
  "card-flywheel-domain-review-history-lib": "/card-flywheel-domain-review-history-lib/static-1.315",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.10687",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.2258",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.3625",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.6712",
  "card-lead-insights": "/card-lead-insights/static-1.8745",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.24443",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.942",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.2678",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.25179",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.19544",
  "card-prospecting-research-agent": "/card-prospecting-research-agent/static-1.1633",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.9577",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.11424",
  "crm-actions": "/crm-actions/static-1.4624",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.33852",
  "crm-clv-report": "/crm-clv-report/static-1.2510",
  "crm-data-highlights": "/crm-data-highlights/static-1.36260",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.35490",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.27043",
  "crm-extension": "/crm-extension/static-1.35581",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.18491",
  "crm-properties-list": "/crm-properties-list/static-1.32898",
  "crm-property-history": "/crm-property-history/static-1.10958",
  "crm-quick-actions": "/crm-quick-actions/static-1.12408",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.12836",
  "crm-report": "/crm-report/static-1.36467",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.13055",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.31432",
  "crm-statistics": "/crm-statistics/static-1.25476",
  "custom-events-card-lib": "/custom-events-card-lib/static-1.226",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.3996",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.12063",
  "datawell-report-crm-card": "/datawell-report-crm-card/static-1.13824",
  "deal-summary-components": "/deal-summary-components/static-1.14930",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.21799",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.1137",
  "guided-actions-card": "/guided-actions-card/static-1.8663",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.5739",
  "health-score-card-lib": "/health-score-card-lib/static-1.15346",
  "help-desk-insights-lib-crm-cards": "/help-desk-insights-lib-crm-cards/static-1.17686",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.9286",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.7583",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.25266",
  "lead-scores-card": "/lead-scores-card/static-1.11754",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.28965",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.22555",
  "playbooks-card": "/playbooks-card/static-1.37373",
  "predictive-scores-card": "/predictive-scores-card/static-1.24965",
  "process-guide-cards": "/process-guide-cards/static-1.3303",
  "products-cards-lib": "/products-cards-lib/static-1.3736",
  "purchase-history-lib": "/purchase-history-lib/static-1.14920",
  "ui-google-drive-attachments": "/ui-google-drive-attachments/static-1.947",
  "ui-google-drive-insights": "/ui-google-drive-insights/static-1.948",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6140",
  "ts-schema": "/ts-schema/static-1.2954",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2876",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6810",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2637",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "csstype": "/csstype/static-1.38",
  "jasmine": "/jasmine/static-4.2921",
  "usage-tracker-public": "/usage-tracker-public/static-1.5851",
  "content-assistance-lib": "/content-assistance-lib/static-1.6033",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.20359",
  "customer-data-content": "/customer-data-content/static-1.24088",
  "draft-content-plugins": "/draft-content-plugins/static-1.23664",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.8855",
  "FireAlarmUi": "/FireAlarmUi/static-1.3448",
  "flux-actions": "/flux-actions/static-1.266",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.6202",
  "pipeline-governance-client-types": "/pipeline-governance-client-types/static-1.2992",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.6122",
  "react-virtualized": "/react-virtualized/static-2.73",
  "subscriptions-client": "/subscriptions-client/static-1.40914",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.34799",
  "task-forms-lib": "/task-forms-lib/static-1.35081",
  "autolinker": "/autolinker/static-3.11",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2753",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "calling-error-reporting": "/calling-error-reporting/static-1.29759",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.32851",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.48838",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.16517",
  "project-storage": "/project-storage/static-1.3273",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.64657",
  "crm-export-dialog": "/crm-export-dialog/static-1.4870",
  "customer-data-filters": "/customer-data-filters/static-1.46793",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3283",
  "testing-library": "/testing-library/static-1.120",
  "academy-common-lib": "/academy-common-lib/static-1.9107",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2004",
  "floating-ui": "/floating-ui/static-1.28",
  "framer-motion": "/framer-motion/static-1.40",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.331",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1364",
  "foundations-theming-base": "/foundations-theming-base/static-1.1866",
  "customer-data-associations": "/customer-data-associations/static-1.5779",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5029",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2378",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1686",
  "i18n-data": "/i18n-data/static-1.195",
  "moment-timezone": "/moment-timezone/static-5.51",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.3306",
  "navigation-components": "/navigation-components/static-1.13464",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.5988",
  "property-description-translator": "/property-description-translator/static-1.2409",
  "quartz-core-utils": "/quartz-core-utils/static-1.2190",
  "call-summary": "/call-summary/static-1.31304",
  "reporting-client-types": "/reporting-client-types/static-1.1743",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9034",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "conversations-async-data": "/conversations-async-data/static-2.6240",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7523",
  "conversations-http": "/conversations-http/static-1.3361",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.11218",
  "conversations-message-history": "/conversations-message-history/static-1.9653",
  "routing-ui": "/routing-ui/static-1.15144",
  "hubs-service-types": "/hubs-service-types/static-1.31",
  "salesImages": "/salesImages/static-1.497",
  "trials-service-types": "/trials-service-types/static-1.2660",
  "react-flip-move": "/react-flip-move/static-1.46",
  "feature-store-service-types": "/feature-store-service-types/static-1.3252",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3259",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3243",
  "hub-http-janus": "/hub-http-janus/static-1.631",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.9906",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10458",
  "final-form": "/final-form/static-1.39",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.11650",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.11646",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.5964",
  "integrations-lib": "/integrations-lib/static-1.9785",
  "chatspot-client-types": "/chatspot-client-types/static-1.8308",
  "chatspot-core": "/chatspot-core/static-1.14681",
  "ContentUtils": "/ContentUtils/static-1.62485",
  "sassPrefix": "/sassPrefix/static-1.129",
  "report-customization-components": "/report-customization-components/static-1.8095",
  "reporting-snowflake": "/reporting-snowflake/static-1.49459",
  "activity-history-lib": "/activity-history-lib/static-1.1137",
  "assisted-buying-components": "/assisted-buying-components/static-1.5558",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.11551",
  "company-details-components": "/company-details-components/static-1.4458",
  "company-details-service-types": "/company-details-service-types/static-1.2502",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.1216",
  "flywheel-recent-conversions-lib": "/flywheel-recent-conversions-lib/static-1.807",
  "flywheel-reject-ql-lib": "/flywheel-reject-ql-lib/static-1.828",
  "industries-core": "/industries-core/static-1.5324",
  "payment-method-components": "/payment-method-components/static-1.5113",
  "quote-checkout-common-lib": "/quote-checkout-common-lib/static-1.8815",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.2201",
  "calling-client-interface": "/calling-client-interface/static-1.69151",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.17732",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.16647",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.50289",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4614",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5075",
  "conversations-prop-types": "/conversations-prop-types/static-1.6003",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9639",
  "universal-associations-select": "/universal-associations-select/static-1.9349",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.12959",
  "redux-actions": "/redux-actions/static-3.7",
  "share-transcript-modal": "/share-transcript-modal/static-1.51304",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.50",
  "worker-connection-library": "/worker-connection-library/static-1.11066",
  "SafeStorage": "/SafeStorage/static-1.2970",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.21062",
  "FileManagerCore": "/FileManagerCore/static-1.33122",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.40494",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.11395",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.22327",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.95323",
  "call-timeline-event": "/call-timeline-event/static-1.49916",
  "crm-events": "/crm-events/static-1.54614",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.20823",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.12967",
  "composer-data": "/composer-data/static-1.24997",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.29031",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7485",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14587",
  "conversations-platform": "/conversations-platform/static-1.3058",
  "conversations-thread-data": "/conversations-thread-data/static-1.62067",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.27834",
  "hubspotter-http": "/hubspotter-http/static-1.3372",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-conversations-settings": "/ui-addon-conversations-settings/static-2.26900",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.4983",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5586",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.39220",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.9735",
  "MeetingsLib": "/MeetingsLib/static-2.52763",
  "hub-http-contrib": "/hub-http-contrib/static-1.1749",
  "task-queues": "/task-queues/static-1.27863",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7343",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.35925",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3353",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.1936",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.35498",
  "customer-data-modals": "/customer-data-modals/static-1.3333",
  "merge-modal-lib": "/merge-modal-lib/static-1.6015",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.23967",
  "property-history-panel": "/property-history-panel/static-1.18781",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3834",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.12552",
  "ql-visibility-lib": "/ql-visibility-lib/static-1.3750",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2026",
  "guided-selling-core": "/guided-selling-core/static-1.4270",
  "sales-execution-components": "/sales-execution-components/static-1.7403",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.4786",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3780",
  "policy-lib": "/policy-lib/static-1.5368",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.21731",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.21717",
  "analytics_js": "/analytics_js/static-1.3131",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.17730",
  "feedback-schema": "/feedback-schema/static-1.47708",
  "forms-utils-lib": "/forms-utils-lib/static-1.9876",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.80235",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4036",
  "MeetingsBase": "/MeetingsBase/static-1.54354",
  "outpost": "/outpost/static-1.2909",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.34053",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.41665",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.36745",
  "react-table": "/react-table/static-1.15",
  "sales-clients-common": "/sales-clients-common/static-1.44977",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5434",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.22133",
  "settings-ui-nav": "/settings-ui-nav/static-2.8607",
  "social-components-lib": "/social-components-lib/static-1.28307",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3772",
  "ui-tour-react": "/ui-tour-react/static-1.10519",
  "urlinator": "/urlinator/static-1.3118",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.2241",
  "quotes-client-types": "/quotes-client-types/static-1.30734",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2576",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15411",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.17817",
  "viral-links-lib": "/viral-links-lib/static-1.5433",
  "media-bridge-lib": "/media-bridge-lib/static-1.16346",
  "video-data-lib": "/video-data-lib/static-1.28649",
  "FileManagerImages": "/FileManagerImages/static-1.30773",
  "trellis-story-utils": "/trellis-story-utils/static-1.3122",
  "knowledge-content-types": "/knowledge-content-types/static-1.7596",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8487",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.13009",
  "content-embed-lib": "/content-embed-lib/static-1.5923",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2611",
  "remote-ui": "/remote-ui/static-1.39",
  "ui-extensions": "/ui-extensions/static-1.14275",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.11868",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1506",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8641",
  "immutable-less": "/immutable-less/static-1.3129",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2792",
  "react-window": "/react-window/static-1.13",
  "markdown-it": "/markdown-it/static-1.6",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6808",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10964",
  "dashboard-lib": "/dashboard-lib/static-1.74912",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7202",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.7259",
  "html-to-image": "/html-to-image/static-1.29",
  "reporting-plugins": "/reporting-plugins/static-1.6271",
  "reporting-reports": "/reporting-reports/static-1.60522",
  "data-token-picker": "/data-token-picker/static-1.13723",
  "navigation-messaging": "/navigation-messaging/static-1.2791",
  "attribution-lib": "/attribution-lib/static-1.36834",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.6764",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5227",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3710",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2390",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.4893",
  "idb-keyval": "/idb-keyval/static-1.20",
  "simple-logging-lib": "/simple-logging-lib/static-1.1615",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7199",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5599",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2502",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.37128",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.2760",
  "submissions-lib": "/submissions-lib/static-1.40696",
  "ui-forms-components": "/ui-forms-components/static-1.7871",
  "portal-details-components": "/portal-details-components/static-1.13245",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.8809",
  "ui-product-approvals": "/ui-product-approvals/static-1.23295",
  "customer-success-client-types": "/customer-success-client-types/static-1.13979",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.10997",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.12764",
  "guided-actions-lib": "/guided-actions-lib/static-1.13891",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.10787",
  "fsm": "/fsm/static-1.2264",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.70958",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.61700",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.70965",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.38233",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.39846",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.39847",
  "card-invoices-lib": "/card-invoices-lib/static-1.50264",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.50046",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.50045",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.32057",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.71121",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.50116",
  "card-workflows-lib": "/card-workflows-lib/static-1.67125",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.21114",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.13507",
  "recording-preview-card": "/recording-preview-card/static-1.10949",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.26099",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.22361",
  "process-guide-chirp": "/process-guide-chirp/static-1.3134",
  "gapi-client-types": "/gapi-client-types/static-1.2",
  "google-picker-types": "/google-picker-types/static-1.2",
  "ui-google-drive-picker": "/ui-google-drive-picker/static-1.517",
  "deep-diff": "/deep-diff/static-1.5",
  "academy-service-client": "/academy-service-client/static-1.2664",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.13365",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.7580",
  "cms-field-types": "/cms-field-types/static-1.3350",
  "content-icons-ui": "/content-icons-ui/static-1.1860",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.6553",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2346",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.17442",
  "emoji-regex": "/emoji-regex/static-1.7",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.9937",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2663",
  "buying-experience-components": "/buying-experience-components/static-1.8377",
  "checkout-service-types": "/checkout-service-types/static-1.2758",
  "growth-pro-utils-lib": "/growth-pro-utils-lib/static-1.7516",
  "audio-components": "/audio-components/static-1.4172",
  "video-components": "/video-components/static-1.7003",
  "video-embed": "/video-embed/static-1.29492",
  "conversations-calling-message": "/conversations-calling-message/static-1.53692",
  "crm-events-viz-test-utils": "/crm-events-viz-test-utils/static-1.16454",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.21684",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.5448",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4332",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.3892",
  "re-reselect": "/re-reselect/static-1.4",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6618",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4457",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4454",
  "automation-ui-core": "/automation-ui-core/static-2.15209",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.13571",
  "workspace-components": "/workspace-components/static-1.2482",
  "settings-content-modals": "/settings-content-modals/static-1.39016",
  "forms-ai-lib": "/forms-ai-lib/static-1.1977",
  "react-tinymce": "/react-tinymce/static-1.49835",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1285",
  "tinymce-config": "/tinymce-config/static-2.48961",
  "meetings-client-types": "/meetings-client-types/static-1.2660",
  "messaging-types-lib": "/messaging-types-lib/static-1.39568",
  "apps-service-types": "/apps-service-types/static-1.2786",
  "oauth-service-types": "/oauth-service-types/static-1.2884",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6499",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.1989",
  "stripe-connect-js": "/stripe-connect-js/static-1.36",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.34790",
  "form-builder-ui": "/form-builder-ui/static-1.7667",
  "user-configuration-lib": "/user-configuration-lib/static-1.23777",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.15057",
  "ui-signature-editor": "/ui-signature-editor/static-1.13098",
  "immerable": "/immerable/static-1.2738",
  "social-insights-client-types": "/social-insights-client-types/static-1.17211",
  "automation-ui-routing": "/automation-ui-routing/static-1.14633",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.12355",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.2834",
  "access-control-lib": "/access-control-lib/static-1.9038",
  "EmailComponents": "/EmailComponents/static-1.48182",
  "EmailData": "/EmailData/static-1.46857",
  "redux-less": "/redux-less/static-2.8002",
  "tinymce-themes": "/tinymce-themes/static-1.50929",
  "interframe": "/interframe/static-3.3371",
  "tinymce-data": "/tinymce-data/static-1.35044",
  "tinymce-plugins": "/tinymce-plugins/static-1.52075",
  "ContentData": "/ContentData/static-1.62562",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1397",
  "layout-dnd-components": "/layout-dnd-components/static-1.10506",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9481",
  "app-users-service-client": "/app-users-service-client/static-1.3578",
  "app-users-service-types": "/app-users-service-types/static-1.2984",
  "framework-listing-lib": "/framework-listing-lib/static-2.21543",
  "mini-checkout-client": "/mini-checkout-client/static-1.23739",
  "onboarding-utils": "/onboarding-utils/static-1.3906",
  "ContentComponents": "/ContentComponents/static-2.65443",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.39833",
  "ui-tool-access": "/ui-tool-access/static-1.8612",
  "automation-ui-types": "/automation-ui-types/static-1.13273",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8042",
  "codemirror": "/codemirror/static-5.69",
  "react-codemirror": "/react-codemirror/static-1.9162",
  "layout-data-lib": "/layout-data-lib/static-1.7806",
  "framework-listing-lib-shared-msw-handlers": "/framework-listing-lib-shared-msw-handlers/static-1.6701",
  "touchless-buying-components": "/touchless-buying-components/static-1.3006",
  "merchandise-lib": "/merchandise-lib/static-1.220",
  "data-token-views": "/data-token-views/static-1.13704",
  "simple-menus-core": "/simple-menus-core/static-1.13273",
  "simple-menus-lib": "/simple-menus-lib/static-1.14791",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.27479",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4659",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2429",
  "ContentEditorUI": "/ContentEditorUI/static-2.70828",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2759",
  "web-interactives-components": "/web-interactives-components/static-1.11151",
  "web-interactives-data": "/web-interactives-data/static-1.11152",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "checkout-sdk": "/checkout-sdk/static-3.20582",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2541",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.3617",
  "copilot-plugins": "/copilot-plugins/static-1.5405",
  "cta-picker": "/cta-picker/static-1.30526",
  "editor-components": "/editor-components/static-1.11582",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.6870",
  "error-messaging-js": "/error-messaging-js/static-1.3854",
  "pictos": "/pictos/static-7.158",
  "redux-request-state": "/redux-request-state/static-1.9147",
  "smart-content-core": "/smart-content-core/static-1.36485",
  "smart-content-lib": "/smart-content-lib/static-1.37139",
  "social-composer-lib": "/social-composer-lib/static-1.52654",
  "structured-content-lib": "/structured-content-lib/static-1.19432",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.47039",
  "tinymce-copilot": "/tinymce-copilot/static-1.11029",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.30961",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5630",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.598",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "jquery": "/jquery/static-3.6",
  "ai-rendering-library": "/ai-rendering-library/static-1.4306",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.7620",
  "fuzzy": "/fuzzy/static-1.8",
  "codemirror-dlb": "/codemirror-dlb/static-1.52380",
  "redux-undo": "/redux-undo/static-1.10",
  "highlight.js": "/highlight.js/static-1.45"
}
};
